import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { SamplepoCopyLinesService } from "../../../../core/services/samplepo-copy-lines.service";
import { debounceTime, distinctUntilChanged, Subject } from "rxjs";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { GenericFilterRequestDto } from "../../../../core/models/generic-filter-request.dto";
import { GenericRequestDto } from "../../../../core/models/generic-request.dto";
import { GenericSortRequestDto } from "../../../../core/models/generic-sort-request.dto";
import { GetAllSamplePOWithLinesDto } from "../../../../core/models/samplePO/add/getAllSamplePOWithLinesDto";
import { CopyPOHeaderRequestDto } from "../../../../core/models/samplePO/details/copyPOHeaderRequestDto";
import { CopyPOLinesRequestDto } from "../../../../core/models/samplePO/details/copyPOLinesRequestDto";
import { ClientsListingService } from "../../../../core/services/clients-listing.service";
import { LoaderService } from "../../../../core/services/loader.service";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { DialogModule } from "primeng/dialog";
import { TableLazyLoadEvent, TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { PurchaseOrderLineSummary } from "../../../../core/models/samplePO/details/samplePOSummaryDto";
import { PurchaseOrderLine } from "../../../../core/models/samplePO/details/purchaseOrderLine";
import { GetAllSamplepo } from "../../../../core/models/samplePO/details/getAllSamplepo";

@UntilDestroy()
@Component({
  selector: "jni-samplepo-copy-header",
  templateUrl: "./samplepo-copy-header.component.html",
  styleUrls: ["./samplepo-copy-header.component.scss"],
  imports: [DialogModule, TableModule, CommonModule, HidedynamicsdatePipe],
})
export class SamplepoCopyHeaderComponent {
  @Input() displayModal = false;
  @Input() samplePONumber = "";
  @Output() closeDialogEvent = new EventEmitter();
  @Output() refreshGridEvent = new EventEmitter();
  @Output() samplePORedirect = new EventEmitter<{
    url: string;
    samplePONumber: string;
  }>();

  samplePOHeader: GetAllSamplePOWithLinesDto[] = [];
  selectedSamplePOHeader!: GetAllSamplePOWithLinesDto;

  samplePOLine: PurchaseOrderLineSummary[] = [];
  selectedSamplePOLine: PurchaseOrderLineSummary[] = [];

  samplePOListings: GetAllSamplepo[] = [];
  selectedSamplePO: PurchaseOrderLine = {} as PurchaseOrderLine;

  lazyLoadEvent!: TableLazyLoadEvent;
  filterDebounceTime = 1000;
  filterTextChanged: Subject<Event> = new Subject<Event>();

  totalRecords = 0;
  defaultTake = 20;

  constructor(
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _samplepoCopyLinesService: SamplepoCopyLinesService,
    private _router: Router,
    private _samplepoListingService: SamplepoListingService,
    public _clientsListingService: ClientsListingService
  ) {}

  closeDialog() {
    //this.selectedSamplePOHeader = [];
    this.selectedSamplePOLine = [];
    this.closeDialogEvent.emit();
  }

  // getSamplePoLines() {
  //   this._loaderService.setLoaderState(true);
  //   this._samplepoCopyLinesService.GetAllSamplePOWithLinesDto().subscribe({
  //     next: (res) => {
  //       this._loaderService.setLoaderState(false);
  //       if (res.data) {
  //         this.samplePOHeader = res.data;
  //       }
  //     },
  //     error: (res) => {
  //       this._loaderService.setLoaderState(false);
  //     }
  //   });
  // }

  // getLineAgainstHeader() {
  //   this.samplePOLine = [];
  //   this.selectedSamplePOLine = [];

  //   if (this.samplePOHeader && this.samplePOHeader.length > 0) {
  //     const linesArray: PurchaseOrderLine[] = [];
  //     this.selectedSamplePOHeader.purchaseOrderLines?.forEach((a) => {
  //       linesArray.push(a);
  //     });

  //     this.samplePOLine = linesArray;
  //   }
  // }

  getCurrentSamplePo(accountnumber: string) {
    this._router.navigate(["/samplepo/samplepo-summary/" + accountnumber]);
  }

  onSamplePORedirection() {
    this._router.navigate(["samplepo/add-samplepo"]);
  }

  getAllSamplepoListingData(event: TableLazyLoadEvent) {
    this.samplePOLine = [];
    this.selectedSamplePOLine = [];
    this.samplePOListings = [];
    this.selectedSamplePO = {} as PurchaseOrderLine;

    this.lazyLoadEvent = event;
    this._loaderService.setLoaderState(true);
    const eventFilterArray = Object.keys(event.filters ?? {});
    const filter: GenericFilterRequestDto[] = eventFilterArray.map(x => {
      return {
        columnName: x || "",
        matchMode: event.filters?.["matchMode"] ?? "",
        tableName: "",
        value: event?.filters?.["value"] ?? "",
      } as GenericFilterRequestDto;
    });

    const sortArray: GenericSortRequestDto[] =
      event.multiSortMeta?.map(x => {
        return {
          ...x,
        } as GenericSortRequestDto;
      }) ?? [];

    filter.forEach(x => {
      if (x.columnName == "purchaseOrderNumber") {
        x.columnName = "PurchaseOrderNumberD365";
        x.tableName = "PurchaseOrderHeader";
      }
      if (x.columnName == "vendorName") {
        x.columnName = "VendorOrganizationNameD365";
        x.tableName = "Vendor";
      }
      if (x.columnName == "jobName") {
        x.columnName = "JobNameD365";
        x.tableName = "PurchaseOrderHeader";
      }
      if (x.columnName == "bcName") {
        x.columnName = "FirstName,LastName";
        x.tableName = "Employee";
      }
      if (x.columnName == "status") {
        x.columnName = "PurchaseOrderStatusD365";
        x.tableName = "PurchaseOrderHeader";
      }
    });
    const request: GenericRequestDto = {
      skip: event.first ?? 0,
      take: event.rows ?? this.defaultTake,
      filters: filter,
      sort: sortArray,
    };

    this._samplepoListingService
      .getAllSamplePOPaginated(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.samplePOListings = res.data;
          this.totalRecords = res.totalRecords ?? 0;
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  selectRow(checkValue: boolean, purchaseOrderNumber: string) {
    if (checkValue) {
      this.getLineAgainstSamplePOHeader(purchaseOrderNumber);
    } else {
      this.samplePOLine = [];
      this.selectedSamplePOLine = [];
      this.selectedSamplePO = {} as PurchaseOrderLine;
    }
  }

  getLineAgainstSamplePOHeader(purchaseOrderNumber: string) {
    this._loaderService.setLoaderState(true);
    this._samplepoCopyLinesService
      .getAllSamplePOLines(purchaseOrderNumber)
      .subscribe({
        next: res => {
          if (res.data) {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this.samplePOLine = res.data;
            } else {
              this._toastr.error("Error", res.message || "No line item found");
            }
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "No line item found");
        },
      });
  }

  saveHeader() {
    this._loaderService.setLoaderState(true);

    let samplePoLine = [];

    if (this.selectedSamplePOLine.length > 0) {
      samplePoLine = this.selectedSamplePOLine;
    } else {
      samplePoLine = this.samplePOLine;
    }

    const addUpdateSamplePOLineDto: CopyPOLinesRequestDto = {
      purchaseOrderLine: samplePoLine,
      purchaseOrderNumber: samplePoLine[0]?.purchaseOrderNumberD365 ?? "",
    };
    const copyHeaderDto: CopyPOHeaderRequestDto = {
      purchaseOrderNumber: samplePoLine[0]?.purchaseOrderNumberD365 ?? "",
      copyPOLinesRequestDto: addUpdateSamplePOLineDto,
    };
    this._samplepoCopyLinesService.copyPOHeader(copyHeaderDto).subscribe({
      next: res => {
        if (res.data) {
          //this.selectedSamplePOHeader = [];
          this.selectedSamplePOLine = [];
          // this.refreshGridEvent.emit();
          this.closeDialog();
          this._loaderService.setLoaderState(false);
          this._toastr.success("Success", "Copy Header Successfully");
          const url = `/samplepo/samplepo-summary/${res.data}`;
          this.samplePORedirect.emit({ url, samplePONumber: res.data });
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Error Copying Header");
      },
    });
  }

  onFilterInput($event: Event) {
    if (this.filterTextChanged.observers.length === 0) {
      this.filterTextChanged
        .pipe(debounceTime(this.filterDebounceTime), distinctUntilChanged())
        .subscribe(() => {
          this.getAllSamplepoListingData(this.lazyLoadEvent);
        });
    }
    this.filterTextChanged.next($event);
  }
}
